type GetMessagePrimaryKeyParams = {
  message: {
    id: string;
    channelId: string;
  };
};

/**
 * @description ChatMessageEntity의 고유 키를 생성합니다.
 * ChatMessageEntity의 id는 단일 채널 내에서만 고유한 값이므로, 채널 id와 메시지 id를 묶어 고유 키를 생성합니다.
 */
export const getMessagePrimaryKey = ({ message }: GetMessagePrimaryKeyParams) =>
  `${message.channelId}:${message.id}`;
